import React, { useEffect, useState, useRef } from "react";
import { Modal, Dropdown } from "react-bootstrap";
import PropTypes from "prop-types";
import "./Step.css";
import "./LoginPopup.css";
import "../../assets/css/component.css";
import "../../assets/css/modal.css";
import warley from "../../assets/svgs/warley.svg";
import { useForm } from "react-hook-form";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { checkContactNo } from "../../actions/authActions";
import { submitOrder } from "../../actions/productActions";
import "../../assets/css/form.css"
import { RiArrowDropDownFill, RiArrowDropUpFill } from "react-icons/ri";
import { BsPhone } from "react-icons/bs";
import ReCAPTCHA from "react-google-recaptcha";
import ModalCloseButton from "../ModalCloseButton/ModalCloseButton";

const Step2 = (props) => {
  const { register, handleSubmit, reset } = useForm();

  const [phoneCode, setPhoneCode] = useState('+65');
  const [phoneCodeVal, setPhoneCodeVal] = useState("SG")
  const phoneCodeElement = useRef(null)
  const [phoneNumber, setPhoneNumber] = useState('');

  const [phoneNoStatus, setPhoneNoStatus] = useState("ERROR");
  const [canSubmit, setSubmitState] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const recaptchaRef = useRef(null);

  const queryParams = new URLSearchParams(window.location.search);
  let business_id = queryParams.get('business_id');
  let location_id = queryParams.get('location_id');

  const handleCaptchaChange = (token) => {
    setCaptchaVerified(!!token);
  };

  const onSubmit = (data) => {
    if (!captchaVerified) {
      return;
    }
    // let oldData = { ...props.signInVal, ...data };
    props.setLoginValue({ 'contact_number': phoneCode + phoneNumber });
    props.checkContactNo({
      'contact_number': phoneCode + phoneNumber,
      'country_code': phoneCodeVal,
      'partial_number': phoneNumber,
      'country_code_value': phoneCode,
      business_id,
      location_id
    });
    setPhoneNumber("");
    reset();
  };

  const countries = [
    {
      'name': 'SG',
      'phoneCode': '+65'
    },
    {
      'name': 'IN',
      'phoneCode': '+91'
    }
  ]

  function updatePhoneCode(event) {
    var newPhoneCode = event.target.value;
    console.log(event.target.name)
    setPhoneCodeVal(event.target.name)
    setPhoneNumber(phoneNumber.replace(phoneCode, newPhoneCode));
    setPhoneCode(newPhoneCode);
  }

  function updatePhoneNumber(event) {
    var inputPhoneNum = event.target.value;

    setPhoneNumber(inputPhoneNum);

  }

  // if (document.querySelector("#LoginBtn")) { //Check if not null
  //   if (canSubmit === false) {
  //     document.querySelector("#LoginBtn").style.opacity = 0.5
  //     document.querySelector("#LoginBtn").disabled = true
  //   } else {
  //     document.querySelector("#LoginBtn").style.opacity = 1.0
  //     document.querySelector("#LoginBtn").disabled = false
  //   }
  // }

  useEffect(() => {
    if (props.isRegistered !== null) {
      if (props.isRegistered) {
        props.setShow(3);
      }
      else { // proceed sign up
        if (props.setSignup) {
          props.setShow(null);
          props.setSignup(1);
        }
      }
    }
  }, [props.isRegistered, props.user?.is_new_user, props.setSignup])

  useEffect(() => {
    if (props.user && props.user?.email) {
      props.setLoginValue({
        'email': props?.user?.email,
        'username': props?.user?.username
        // 'contact_number': props?.user?.contact_number
      });
    }
  }, [props.user])


  useEffect(() => {
    const phoneNoRegex = /^(6|8|9)\d{7}$/;
    const indRegex = /^(6|7|8|9)\d{9}$/;

    setSubmitState(false);
    console.log(phoneNumber);
    console.log(phoneCode);

    console.log(canSubmit);

    if (!phoneNumber) {
      setPhoneNoStatus("");
      return;
    }

    if (phoneNumber === phoneCode || phoneNumber === "") {
      setPhoneNoStatus("");
    } else {
      if (phoneCode === '+91' && indRegex.test(phoneNumber)) {
        setPhoneNoStatus(<div className="footer-warley-description text-success">Valid Phone Number</div>)
        setSubmitState(true);
      } else if (phoneCode === '+65' && phoneNoRegex.test(phoneNumber)) {
        setPhoneNoStatus(<div className="footer-warley-description text-success">Valid Phone Number</div>)
        setSubmitState(true);
      } else {
        setPhoneNoStatus(<div className="footer-warley-description text-danger">Invalid Phone Number</div>)
      }
    }




  }, [phoneNumber, phoneCode])

  return (
    <Modal
      show={props.show}
      onHide={props.closeModal}
      dialogClassName="login-popup-dialog"
      contentClassName="login-popup-content"
      centered
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        {/* ---- Close button ---- */}
        <ModalCloseButton onClick={props.closeModal} />

        <Modal.Body className="lp-body">
          {/* ---- Logo ---- */}
          <div className="lp-logo-wrap">
            <img src={warley} className="lp-logo" alt="Warely" />
          </div>

          {/* ---- Title & subtitle ---- */}
          <div className="lp-title">Log in / Sign up</div>
          <div className="lp-subtitle">
            Enter your mobile number<br />
            we'll take you to register or login automatically.
          </div>

          {/* ---- Phone number label ---- */}
          <label className="lp-label">Phone Number</label>

          {/* ---- Phone input group ---- */}
          <div className="lp-phone-group">
            {/* Country dropdown */}
            <Dropdown onToggle={(isOpen) => setShowDropdown(isOpen)}>
              <Dropdown.Toggle
                id="dropdown-phone-code"
                className="lp-country-toggle"
              >
                {phoneCodeVal ? phoneCodeVal : "Select"}
                {showDropdown ? (
                  <RiArrowDropUpFill style={{ fontSize: '18px' }} />
                ) : (
                  <RiArrowDropDownFill style={{ fontSize: '18px' }} />
                )}
              </Dropdown.Toggle>

              <Dropdown.Menu className="lp-country-menu">
                {countries.map(({ name, phoneCode: code }) => (
                  <Dropdown.Item
                    key={name}
                    active={phoneCode === code}
                    onClick={() => {
                      setPhoneCode(code);
                      setPhoneCodeVal(name);
                    }}
                  >
                    {name} {code}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            {/* Phone prefix display */}
            <div ref={phoneCodeElement} className="lp-phone-prefix">{phoneCode}</div>

            {/* Number input */}
            <input
              data-testid="phone_number_id"
              autoComplete="off"
              required
              {...register("phone")}
              id="inlineFormInputGroupUsername2"
              type="tel"
              inputMode="numeric"
              placeholder="Enter phone number"
              minLength="8"
              className="lp-phone-input"
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              onChange={updatePhoneNumber}
              value={phoneNumber}
            />

            {/* Phone icon on right */}
            <span className="lp-phone-icon">
              <BsPhone />
            </span>
          </div>

          {/* ---- Validation status ---- */}
          <div className="lp-status">{phoneNoStatus}</div>

          {/* ---- reCAPTCHA ---- */}
          <div className="lp-captcha">
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
              onChange={handleCaptchaChange}
              onExpired={() => setCaptchaVerified(false)}
              ref={recaptchaRef}
            />
          </div>
        </Modal.Body>

        <Modal.Footer className="lp-footer">
          <button
            data-testid="log_in"
            type="submit"
            className="lp-submit-btn"
            id="LoginBtn"
            disabled={!canSubmit || !captchaVerified}
          >
            Log in / Sign up
          </button>
          <div className="lp-powered">Powered by Warely</div>
        </Modal.Footer>
      </form>
    </Modal>
  );
};
Step2.propTypes = {
  closeModal: PropTypes.func.isRequired,
  // showNext: PropTypes.func.isRequired,
};
// export default Step2;

const mapStateToProps = (state) => ({
  isRegistered: state.auth.isRegistered,
  user: state.auth.user
});
export default withTranslation()(
  connect(mapStateToProps, { checkContactNo })(Step2)
);